import React from 'react';
import { useSelector } from 'react-redux';

import { Divider } from 'antd';

import userSelectors from '@redux/user/selectors';

import Multifactor from './authentication/Multifactor';
import ChangePassword from './change-password/ChangePassword';

import SecurityItemContainer from './common/SecurityItemContainer';
import OktaSso from './sso/OktaSso';
import MicrosoftEntraID from './sso/MicrosoftEntraID';

import './UserSecurityTab.less';
import SecurityItemWrapperContent from './common/SecurityItemWrapperContent';

const UserSecurityTab = (props) => {
  const { userProfile = {}, editable } = props;
  const userInfo = useSelector(userSelectors.makeSelectUserInfo()) || {};
  const {
    passwordExpiration,
    requireMfa,
    mfaPhoneNumber,
    oktaEmail,
    microsoftEmail,
  } = userProfile || {};

  const isAllowToChangePassword = editable && userInfo?.id === userProfile?.id;
  const isAllowToChangeMfaPhoneNumber =
    editable && userInfo?.id === userProfile?.id && requireMfa;

  return (
    <div className='user-security-tab__wrapper'>
      <div className='user-security-tab__fluid'>
        <SecurityItemContainer title='Multi-factor Authentication'>
          <SecurityItemWrapperContent>
            <Multifactor.Label slot='label' mfaPhoneNumber={mfaPhoneNumber} />

            <Multifactor.Status slot='status' requireMfa={requireMfa} />

            <Multifactor.Control
              slot='control'
              isAllowToChangeMfaPhoneNumber={isAllowToChangeMfaPhoneNumber}
            />
          </SecurityItemWrapperContent>
        </SecurityItemContainer>

        <SecurityItemContainer title='Change Password'>
          <SecurityItemWrapperContent>
            <ChangePassword.Label
              slot='label'
              passwordExpiration={passwordExpiration}
            />

            <ChangePassword.Status
              slot='status'
              passwordExpiration={passwordExpiration}
            />

            <ChangePassword.Control
              slot='control'
              isAllowToChangePassword={isAllowToChangePassword}
            />
          </SecurityItemWrapperContent>
        </SecurityItemContainer>

        <SecurityItemContainer title='SSO'>
          <SecurityItemWrapperContent>
            <OktaSso.Label slot='label' oktaEmail={oktaEmail} />

            <OktaSso.Status slot='status' />

            <OktaSso.Control slot='control' userProfile={userProfile} />

          </SecurityItemWrapperContent>

          <Divider style={{ margin: '8px 0' }} />

          <SecurityItemWrapperContent>
            <MicrosoftEntraID.Label
              slot='label'
              microsoftEmail={microsoftEmail}
            />

            <MicrosoftEntraID.Status slot='status' />
            
            <MicrosoftEntraID.Control
              slot='control'
              userProfile={userProfile}
            />
          </SecurityItemWrapperContent>
        </SecurityItemContainer>
      </div>
    </div>
  );
};

export default UserSecurityTab;
